import { TAG_ENTITY_MAIN_KEY } from 'Utils/tags/constants';
import { TagEntityScaledDataKeys } from 'Utils/tags/types';
// Sub panels
export const SUB_PANEL_VIEWS = {
    TAGS: 'Tags',
    TABLE: 'Tags List',
    HEATMAP: 'Heatmap'
};
export const SUB_PANEL_VIEWS_OPTIONS = [
    { value: SUB_PANEL_VIEWS.TAGS, label: 'Graphs' },
    { value: SUB_PANEL_VIEWS.HEATMAP, label: 'Heatmap' },
    { value: SUB_PANEL_VIEWS.TABLE, label: 'List' }
];
// Cards display
export var TagsDisplayOptionsEnum;
(function (TagsDisplayOptionsEnum) {
    TagsDisplayOptionsEnum["StillData"] = "Still_data";
    TagsDisplayOptionsEnum["ReconstructedValue"] = "Reconstructed_value";
    TagsDisplayOptionsEnum["ImputedData"] = "Imputed_data";
    TagsDisplayOptionsEnum["ReconstructedVersions"] = "Reconstructed_versions";
    TagsDisplayOptionsEnum["Distribution"] = "Distribution";
    TagsDisplayOptionsEnum["TrainingPeriod"] = "Training_period";
    TagsDisplayOptionsEnum["CurrentEventHighlight"] = "Current_event_highlight";
})(TagsDisplayOptionsEnum || (TagsDisplayOptionsEnum = {}));
export const TAGS_DISPLAY_OPTIONS = {
    [TagsDisplayOptionsEnum.StillData]: {
        isChecked: false,
        text: 'Stand still data'
    },
    [TagsDisplayOptionsEnum.ReconstructedValue]: {
        isChecked: true,
        text: 'Reconstructed value',
        linkedOptionKey: TagsDisplayOptionsEnum.ReconstructedVersions
    },
    [TagsDisplayOptionsEnum.ImputedData]: {
        isChecked: true,
        text: 'Imputed data'
    },
    [TagsDisplayOptionsEnum.ReconstructedVersions]: {
        isChecked: true,
        text: 'Versions markers',
        isDisabled: false
    },
    [TagsDisplayOptionsEnum.Distribution]: {
        isChecked: true,
        text: 'Distribution'
    },
    [TagsDisplayOptionsEnum.TrainingPeriod]: {
        isChecked: true,
        text: 'Training Period'
    },
    [TagsDisplayOptionsEnum.CurrentEventHighlight]: {
        isChecked: false,
        text: 'Current event highlight'
    }
};
export const VALUES_LABELS = {
    ACTUAL: 'Actual value',
    RECONSTRUCTED: 'Reconstructed value',
    IMPUTED: 'Imputed data'
};
export const SUB_PANEL_SORTING = {
    CONTRIBUTION_LAST_3_DAYS: {
        field: TagEntityScaledDataKeys.SCALED_DATA_AVG_LAST_THREE_DAYS,
        text: 'Contribution: last 3 days'
    },
    CONTRIBUTION: {
        field: TagEntityScaledDataKeys.SCALED_DATA_AVG,
        text: 'Contribution: loaded period'
    },
    ALPHABETICAL: {
        field: TAG_ENTITY_MAIN_KEY,
        text: 'Alphabetical'
    }
};
export const SUB_PANEL_SORTING_IMPUTED = {
    CONTRIBUTION_LAST_3_DAYS_IMPUTED: {
        field: TagEntityScaledDataKeys.SCALED_DATA_AVG_LAST_THREE_DAYS_IMPUTED,
        text: 'Contribution imputed included: last 3 days'
    },
    CONTRIBUTION_IMPUTED: {
        field: TagEntityScaledDataKeys.SCALED_DATA_AVG_IMPUTED,
        text: 'Contribution imputed included: loaded period'
    },
    ...SUB_PANEL_SORTING
};
export const PROCESSING_INTERVAL = 10;
